<template>
  <validation-observer v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleLogIn)">
      <b-row cols="1">
        <b-col>
          <validation-provider
            v-slot="{ failed, errors }"
            rules="required|email"
            mode="eager"
          >
            <simple-form-input
              :hasError="failed"
              :helperText="errors[0]"
              :label="$t('general.email')"
              v-model="email"
              type="email"
              data-cy="input-login"
              autocomplete="email"
            />
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider v-slot="{ failed, errors }" rules="required">
            <simple-form-input
              :hasError="failed"
              :helperText="errors[0]"
              :label="$t('general.password')"
              v-model="password"
              type="password"
              data-cy="input-password"
              autocomplete="current-password"
            />
          </validation-provider>
        </b-col>
      </b-row>
      <b-row cols="1">
        <b-col>
          <router-link to="/forgottenPassword">{{
            $t("loginForm.forgotPassword")
          }}</router-link>
        </b-col>
        <b-col class="login-controls">
          <b-button
            type="submit"
            :disabled="isLoggingIn"
            data-cy="button-login"
          >
            <b-spinner v-if="isLoggingIn" small />
            {{ $t("general.logIn") }}
          </b-button>
          <b-button
            variant="primary"
            to="/register"
            data-cy="button-registration"
          >
            {{ $t("loginForm.register") }}
          </b-button>
          <div class="google-btn-wrapper">
            <b-button
            variant="primary"
              :disabled="isLoggingIn"
              @click="loginWithGoogle"
              class="google-btn"
            >
              <img src="https://developers.google.com/identity/images/g-logo.png" width="18">
              Sign in with Google
            </b-button>
          </div>
        </b-col>
      </b-row>
    </form>
  </validation-observer>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MainAlert from "../alerts/MainAlert.vue";
import SimpleFormInput from "../inputs/SimpleFormInput.vue";
export default {
  name: "login-form",
  components: { SimpleFormInput },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  computed: {
    ...mapGetters({
      restAuthUrl: "getRestAuthUrl",
      user: "getUser",
      isLoggingIn: "getLoginStatus",
      loginError: "getLoginError",
    }),
  },
  mounted() {
    this.initializeGoogleSignIn();
  },
  methods: {
    ...mapActions(["logIn", "loginWithToken", "logOut"]),
    initializeGoogleSignIn() {
      // eslint-disable-next-line no-undef
      if (typeof google !== 'undefined' && google.accounts) {
        this.setupGoogleSignIn();
      } else {
        // Wait for google to load
        const checkGoogleLoaded = setInterval(() => {
          // eslint-disable-next-line no-undef
          if (typeof google !== 'undefined' && google.accounts) {
            clearInterval(checkGoogleLoaded);
            this.setupGoogleSignIn();
          }
        }, 100);
        
        // Timeout after 10 seconds
        setTimeout(() => {
          clearInterval(checkGoogleLoaded);
        }, 10000);
      }
    },
    setupGoogleSignIn() {
      // eslint-disable-next-line no-undef
      this.codeClient = google.accounts.oauth2.initTokenClient({
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          scope: "openid email profile https://www.googleapis.com/auth/userinfo.email",
          ux_mode: "popup",
          callback: this.handleCredentialResponse
        });
    },
    loginWithGoogle() {
      this.codeClient.requestAccessToken();
    },
    handleLogIn() {
      this.logIn({
        email: this.email,
        password: this.password,
      }).catch(() => {
        if (this.loginError) {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.loginError,
            },
          })
        } else {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.$i18n.t("general.wrongCredentials"),
            },
          })
        }
      });
    },
    handleCredentialResponse(response) {
      this.loginWithToken(response).catch(() => {
        if (this.loginError) {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.loginError,
            },
          })
        } else {
          this.$toast.error({
            component: MainAlert,
            props: {
              message: this.$i18n.t("general.wrongCredentials"),
            },
          })
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.login-controls {
  .btn {
    display: block;
    margin: 0 auto;
    margin-bottom: toRem(34);
    width: toRem(250);
  }
}
.google-btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>